module.exports = __webpack_public_path__ + "static/media/Jpeg.c1c10e00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/Jpeg.svg
// module id = 1671
// module chunks = 17